import { ConsultaModel } from './../interfaces/consulta.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private baseUrl = `${environment.apiEndpoint}/home`;

  constructor(private http: HttpClient) {}

  enviarConsulta(consulta: ConsultaModel) {
    return this.http.post(`${this.baseUrl}/contactus`, consulta);
  }
}
